module.exports = __webpack_public_path__ + "static/long-live-the-queen_glass_hair_found-objects_freshwater-pearls-132c4f1f2c90717f326d52d2dd500681.jpg";